import {createAction} from "redux-act";

export const handleModalState = createAction<{[key: string]: boolean}>();
export const showFanFact = createAction<number>();
export const hideFanFact = createAction();
